export const PARTNER_CONTRACT_DOCUMENT_ID = "partnerContract";
export const PARTNER_CONTRACT_SLOT = "partnerContract";
export const PARTNER_CONTRACT_DEFAULT_EMAIL = "zoryana@chasmaistriv.com.ua";
export const PARTNER_CONTRACT_MAX_FILE_SIZE = 20 * 1024 * 1024;

export const DEFAULT_PARTNER_CONTRACT = {
  type: "email",
  email: PARTNER_CONTRACT_DEFAULT_EMAIL,
  url: "",
  fileName: "",
  storagePath: "",
};

const ALLOWED_CONTRACT_EXTENSIONS = new Set([
  "pdf",
  "doc",
  "docx",
  "odt",
  "rtf",
]);
const ALLOWED_CONTRACT_MIME_TYPES = new Set([
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.oasis.opendocument.text",
  "application/rtf",
  "text/rtf",
]);

function asText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function normalizeContractEmail(value) {
  return asText(value).replace(/^mailto:/i, "").trim();
}

export function isValidContractEmail(value) {
  const email = normalizeContractEmail(value);
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function normalizeContractFileUrl(value) {
  const rawUrl = asText(value);
  if (!rawUrl) return "";

  try {
    const parsedUrl = new URL(rawUrl);
    return parsedUrl.protocol === "https:" || parsedUrl.protocol === "http:"
      ? parsedUrl.href
      : "";
  } catch {
    return "";
  }
}

export function normalizePartnerContract(value = {}) {
  const email = normalizeContractEmail(value.email);

  return {
    type: value.type === "file" ? "file" : "email",
    email: isValidContractEmail(email)
      ? email
      : PARTNER_CONTRACT_DEFAULT_EMAIL,
    url: normalizeContractFileUrl(value.url),
    fileName: asText(value.fileName),
    storagePath: asText(value.storagePath),
  };
}

export function isPartnerContractFileLink(value) {
  const contract = normalizePartnerContract(value);
  return contract.type === "file" && Boolean(contract.url);
}

export function buildPartnerContractHref(value) {
  const contract = normalizePartnerContract(value);
  return contract.type === "file" && contract.url
    ? contract.url
    : `mailto:${contract.email}`;
}

export function validatePartnerContractFile(file) {
  if (!file) return "Оберіть файл договору.";

  const extension = asText(file.name).split(".").pop()?.toLowerCase();
  if (!extension || !ALLOWED_CONTRACT_EXTENSIONS.has(extension)) {
    return "Дозволені формати: PDF, DOC, DOCX, ODT або RTF.";
  }

  if (file.type && !ALLOWED_CONTRACT_MIME_TYPES.has(file.type)) {
    return "Тип вибраного файлу не відповідає документу договору.";
  }

  if (Number(file.size) > PARTNER_CONTRACT_MAX_FILE_SIZE) {
    return "Розмір файлу не повинен перевищувати 20 МБ.";
  }

  return "";
}

export function makeContractStorageFileName(fileName) {
  const safeName = asText(fileName)
    .replace(/[^\wа-яА-ЯіїєґІЇЄҐ.-]+/g, "_")
    .replace(/^\.+/, "");

  return safeName || "partner-contract.pdf";
}
